<template>
    <div @mouseenter="isDropdownFocused=true" @mouseleave="isDropdownFocused=false"
         class="dropdown-list dropdown-autocomplete">
        <div class="dropdown-wrapper" v-show="showDropdown">
            <ul>
                <li :class="[{ 'current' : result === current},{'selected' : result === selected}]"
                    v-for="(result) in results">
                    <component @input="select($event)" v-bind:current="result === current"
                               v-bind:is="getResultType(result)" v-bind:result="result"
                               v-bind:select="result === selected">

                    </component>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Autocomplete from "@trevoreyre/autocomplete-vue";

    export default {
        name: "VisualTokenDropdown",
        props: ['input', 'elem', 'results', 'getResults', 'resultConfig'],
        data: function () {
            return {
                isDropdownFocused: false,
                isInputFocused: false,
                showDropdown: false,
                currentIndex: -1,
                selected: null,
            }
        },
        comments: {
            Autocomplete
        },
        created() {
            this.showDropdown = this.results.length > 0;
            let self = this;

            document.addEventListener('click',function (event) {
              console.log(event);
              const inside = typeof event.composedPath === 'function' &&  !event.composedPath().includes(self.$parent.$el);
              if(!inside)
              {
                self.showDropdown = false;
              }
            })
        },
        mounted() {

        },
        computed: {
            current() {
                let result;

                if (this.currentIndex >= 0)
                    return (result = this.results[this.currentIndex]) ? result : null;
                return null;
            }
        },
        watch: {
            input(newVal, OldVal) {},
            results() {
                this.isInputFocused ? this.showDropdown = true : this.showDropdown = false;
                this.currentIndex = -1;
            },
            currentIndex() {
                this.currentIndex >= 0 ? this.$emit('active') : this.$emit('inactive');
            },
            elem() {
                let $this = this;
                this.isInputFocused = this.elem == document.activeElement;
                this.elem.addEventListener('focus', function (e) {
                    $this.$nextTick(() => {
                        $this.isInputFocused = true;
                        $this.showDropdown = true;
                    });
                });
                this.elem.addEventListener('blur', function (e) {
                    $this.$nextTick(() => {
                        $this.isInputFocused = false;
                        if (!$this.isDropdownFocused)
                            $this.showDropdown = false;
                    });
                });
                this.elem.addEventListener('keyup', function (e) {
                    $this.$nextTick(() => {
                        this.showDropdown = true;
                        // down
                        if (e.keyCode === 40) {
                            $this.currentIndex = Math.min($this.results.length - 1, $this.currentIndex + 1);
                        }
                        // Up
                        if (e.keyCode === 38) {
                            $this.currentIndex = Math.max(0, $this.currentIndex - 1);
                        }
                        // Return
                        if (e.keyCode === 13) {
                            $this.select($this.current);
                        }
                        // Esc
                        if (e.keyCode === 27) {
                            $this.showDropdown = false;
                        }
                    });

                })
            },

        },
        methods: {
            getResultType(result) {
                if (!!result.type && this.resultConfig[result.indexname]) {
                    return this.resultConfig[result.indexname];
                }

                return this.resultConfig['default'];
            },
            select(item) {
                if (!item) {
                    this.selected = null;
                    return;
                }

                this.selected = this.current;

                this.$emit('select', item);
                this.showDropdown = false;
            },
            click(e){

            }
        }
    }
</script>

<style lang="less" scoped>


</style>
